
import { ArtworkResult } from '@/components/w2pFileUploader';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    title: {
      type: String,
      required: true,
    },
    masterProductSku: {
      type: String,
      default: '',
    },
    productDescription: {
      type: String,
      default: '',
    },
    uploadedFileData: {
      type: Object as PropType<ArtworkResult>,
      default: {},
    },
    fileUrl: {
      type: String,
      default: '',
    },
    selectedMethod: {
      type: String,
      required: true,
    },
    isDetailLost: {
      type: Boolean,
      default: false,
    },
  },
});
